// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Barlow-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Barlow-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Nelphim.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/Hero_BAAcademy.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/BATrainingPillars.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Barlow";
  src: local("Barlow"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
}

@font-face {
  font-family: "BarlowBold";
  src: local("BarlowBold"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}

@font-face {
  font-family: "Nelphim";
  src: local("Nelphim"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
}
.academy-wrapper {
  display: block;
  position: relative;
  padding-top: 30px;
  padding-bottom: 60px;
  height: calc(100vh - 60px);
  width: 100%;
  max-width: 1366px;
  margin-left: auto;
  margin-right: auto;
  display: block;
}


.bg-image-academy {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  width: calc(100% - 120px);
  height: 100%;
  margin-left: 60px;
  border-radius: 30px;
}
.academy-hero-col {
  display: grid;
  grid-template-columns: auto auto;
  gap: 10px;
  height: 100%;
  align-items: center;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
 }
  100% {
    opacity: 1;
 }
}
.academy-hero-bg-col-1 {
  padding: 0px 0px 0px 60px;
  margin-bottom: 15%;
  animation: fadeIn 5s;
}
.academy-hero-bg-col-1 .header-title-left {
  font-family: "Nelphim";
  font-size: 6em;
  color: white;
}
.academy-hero-bg-col-2 {
  padding-top: 10%;
  /* padding-left: 30%; */
  text-align: left;
  animation: fadeIn 5s;
}
.academy-hero-bg-col-2 .header-title-right {
  font-family: "Nelphim";
  font-size: 6em;
  color: white;
}
.academy-btn-hero-group {
  position: absolute;
  margin-top: -120px;
  margin-left: 60px;
}
.section-wwr {
  padding: 60px 0px;
}
.section-wwr-header {
  display: block;
  max-width: 1366px;
  padding-bottom: 60px;
  margin-left: auto;
  margin-right: auto;
}
.wwr-header-text {
  width: calc(100% - 60px);
  display: flex;
}
.wwr-header-text .section-item-1 {
  width: 70%;
  padding: 0px 30px 0px 60px;
}
.wwr-header-text .section-item-2 {
  width: 30%;
  padding: 0px 60px 0px 30px;
}
.wwr-header-image-group {
  display: block;
  max-width: 1366px;
  padding: 0px 0px;
  margin-left: auto;
  margin-right: auto;
}
.wwr-img {
  width: calc(100% - 120px);
  display: block;
  padding: 0px 60px 0px 60px;
  overflow: auto;
}
.wwr-img .wwr-img-group {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  overflow: auto;
}
.wwr-img .wwr-img-group img {
  width: 100%;
  border-radius: 30px;
}
.section-empower {
  display: block;
  max-width: 1366px;
  padding: 60px 0px 60px 0px;
  margin-left: auto;
  margin-right: auto;
}
.section-empower .section-empower-group {
  width: calc(100% - 120px);
  margin-left: auto;
  margin-right: auto;
}
.section-empower .empower-bg-image {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: cover;
 /* <------ */
  background-repeat: no-repeat;
  background-position: center center;
  width: calc(100% - 120px);
  height: 800px;
  border-radius: 30px;
  position: relative;
}
.empower-img-group-mobile {
  display: none;
}
.section-empower-1 {
  padding: 60px;
  width: 65%;
}
.section-empower-2 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 24px;
  padding: 60px 60px 45px 60px;
  position: absolute;
  bottom: 0px;
}
.empower-box {
  padding: 30px;
  border-radius: 30px;
  border: 1px solid #ecebe6;
  background: rgba(252, 252, 252, 0.2);
 /* Glassy Card */
  box-shadow: 0px 119px 33px 0px rgba(135, 135, 135, 0), 0px 76px 31px 0px rgba(135, 135, 135, 0.01), 0px 43px 26px 0px rgba(135, 135, 135, 0.02), 0px 19px 19px 0px rgba(135, 135, 135, 0.04), 0px 5px 10px 0px rgba(135, 135, 135, 0.04);
  backdrop-filter: blur(10px);
}
.empower-box .section-detail-large {
  padding-bottom: 30px;
}
.empower-box .section-detail-small {
  text-align: justify;
}
.section-reape-success {
  display: block;
  max-width: 1366px;
  margin-left: auto;
  margin-right: auto;
  overflow: auto;
  padding: 60px 0px;
}

.business-associate-wrapper{
  display: block;
  max-width: 1366px;
  margin-left: auto;
  margin-right: auto;
  overflow: auto;
  padding: 60px 0px;

}
.reape-grid {
  display: grid;
  grid-template-columns: 40% 60%;
  grid-template-rows: 2fr;
  width: 100%;
  overflow: auto;
}
.reape-success-header-text {
  width: calc(100% - 120px);
  display: flex;
  align-items: center;
  padding-right: 60px;
  padding-left: 60px;
}

.business-associate-header {
  width: calc(100% - 120px);
  display: flex;
  align-items: center;
  padding-right: 60px;
  padding-left: 60px;
  padding-bottom: 60px;
}
.reape-header-image-group {
  width: calc(100% - 120px);
  position: relative;
  padding-left: 60px;
  padding-bottom: 60px;
}
.reape-header-image-group .reape-image {
  display: block;
  width: 100%;
  border-radius: 30px;
}
.reape-ba-image-group {
  width: calc(100% - 60px);
  position: relative;
  padding-left: 60px;
  padding-top: 60px;
}
.reape-ba-image-group .reape-ba-image {
  display: block;
  width: 100%;
  border-radius: 30px;
}
.reape-ba-detail-mobile {
  display: none;
}
.reape-ba-detail-web {
  display: flex;
  justify-content: center;
  align-items: center;
}
.reape-ba-detail-web .detail-web {
  width: 60%;
  text-align: justify;
}
.reape-ba-detail-web .section-detail-large {
  padding-top: 120px;
}
.section-ba-news {
  display: block;
  max-width: 1366px;
  margin-left: auto;
  margin-right: auto;
  overflow: auto;
  padding-bottom: 60px;
  padding-top: 60px;
}
.ba-news-header {
  display: inline-flex;
  padding-left: 60px;
  padding-right: 60px;
  width: calc(100% - 120px);
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom: 60px;
}
.ba-news-header .section-item-2 {
  display: inline-flex;
  gap: 12px;
}

.section-business-associate-content{
  display: block;
  width: calc(100% - 120px);
  margin-left: auto;
  margin-right: auto;
}

.content-slider {
  display: block;
  max-width: 1366px;
  margin-left: auto;
  margin-right: auto;
  overflow: auto;
}
.ba-news-content {
  display: block;
  width: calc(100% - 120px);
  margin-left: auto;
  margin-right: auto;
}
.ba-news-card {
  display: flex;
  width: 100%;
  gap: 24px;
  overflow-x: hidden;
  scroll-behavior: smooth;
  overflow-y: hidden;
}
.ba-news-detail-group {
  width: calc(50% - 15px);
  min-width: calc(50% - 15px);
  background-color: #f7f7f7;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
}
.ba-news-detail-group .ba-news-image {
  border-radius: 20px;
}
.ba-news-inner {
  width: 100%;
  display: flex;
  align-items: flex-start;
}
.ba-news-inner-detail {
  width: 60%;
  padding: 24px 24px 0px 24px;
  line-height: 1.5;
}
.ba-news-inner-detail .detail-flex {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}
.ba-news-image-group {
  width: 40%;
  padding: 24px 24px 24px 0px;
}
.ba-news-image-group .ba-news-image {
  width: 100%;
}
button.left-arrow {
  height: fit-content;
  display: block;
  border-radius: 20px;
  border: 1px solid rgb(122 166 194 / 50%);
  background: #eee;
  backdrop-filter: blur(10px);
  cursor: pointer;
  display: flex;
  padding: 18px 24px;
  justify-content: center;
  align-items: center;
  color: #7ba7c2;
}
button.left-arrow:hover {
  display: block;
  border-radius: 20px;
  border: 1px solid rgb(122 166 194 / 50%);
  background: #7ba7c2;
  backdrop-filter: blur(10px);
  cursor: pointer;
  display: flex;
  padding: 18px 24px;
  justify-content: center;
  align-items: center;
  color: #fcfcfc;
}
button.right-arrow {
  height: fit-content;
  border-radius: 20px;
  border: 1px solid rgb(122 166 194 / 50%);
  background: #eee;
  backdrop-filter: blur(10px);
  cursor: pointer;
  display: flex;
  padding: 18px 24px;
  justify-content: center;
  align-items: center;
  color: #7ba7c2;
}
button.right-arrow:hover {
  display: block;
  border-radius: 20px;
  border: 1px solid rgb(122 166 194 / 50%);
  background: #7ba7c2;
  backdrop-filter: blur(10px);
  cursor: pointer;
  display: flex;
  padding: 18px 24px;
  justify-content: center;
  align-items: center;
  color: #fcfcfc;
}
.section-faq {
  display: block;
  max-width: 1366px;
  margin-left: auto;
  margin-right: auto;
  overflow: auto;
  padding-bottom: 0px;
}
.section-faq-container {
  display: grid;
  padding: 60px;
  width: calc(100% - 120px);
  grid-template-columns: 40% 60%;
  grid-template-rows: 1fr;
  overflow: auto;
}
.business-associate-content{
  display: block;
  max-width: 1366px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: auto;
  text-align: center;
  padding: 0px 60px;
 
}
.business-associate-content-inner{
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  width: 100%;
  position: relative;
  margin-left: auto;
  margin-right: auto;
 
}
.business-associate-content-inner .business-associate-card  {
  width: 100%;
  display: inline-grid;
  text-align: left;
  position: relative;
}

.business-associate-content-inner .business-associate-card .business-associate-img-box {
  border-radius: 30px;
width: 100%;
  background: #d3d1c5;
  display: in;
  position: relative;
  overflow: hidden;
}
.business-associate-content-inner .business-associate-card .business-associate-img-box .business-associate-img {
  width: 100%;
}
.business-associate-content-inner .business-associate-card .business-associate-title-group {
  padding: 20px 0px 0px 0px;
  display: flex;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/assets/style/academy_web.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,4EAAwE;AAC1E;;AAEA;EACE,yBAAyB;EACzB,gFAA2E;AAC7E;;AAEA;EACE,sBAAsB;EACtB,8EAAoE;AACtE;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,0BAA0B;EAC1B,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;;AAGA;EACE,mDAAgD;EAChD,sBAAsB;EACtB,4BAA4B;EAC5B,kCAAkC;EAClC,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE;IACE,UAAU;CACb;EACC;IACE,UAAU;CACb;AACD;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,aAAa;AACf;AACA;EACE,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mDAAmD;EACnD,sBAAsB;CACvB,YAAY;EACX,4BAA4B;EAC5B,kCAAkC;EAClC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,UAAU;AACZ;AACA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;CACrC,gBAAgB;EACf,wOAAwO;EACxO,2BAA2B;AAC7B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;;AAEnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;;AAEnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;;AAEpB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB,WAAW;EACT,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,8BAA8B;AAChC","sourcesContent":["@font-face {\n  font-family: \"Barlow\";\n  src: local(\"Barlow\"), url(\"../fonts/Barlow-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"BarlowBold\";\n  src: local(\"BarlowBold\"), url(\"../fonts/Barlow-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Nelphim\";\n  src: local(\"Nelphim\"), url(\"../fonts/Nelphim.woff2\") format(\"woff2\");\n}\n.academy-wrapper {\n  display: block;\n  position: relative;\n  padding-top: 30px;\n  padding-bottom: 60px;\n  height: calc(100vh - 60px);\n  width: 100%;\n  max-width: 1366px;\n  margin-left: auto;\n  margin-right: auto;\n  display: block;\n}\n\n\n.bg-image-academy {\n  background: url(\"../images/Hero_BAAcademy.webp\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center center;\n  width: calc(100% - 120px);\n  height: 100%;\n  margin-left: 60px;\n  border-radius: 30px;\n}\n.academy-hero-col {\n  display: grid;\n  grid-template-columns: auto auto;\n  gap: 10px;\n  height: 100%;\n  align-items: center;\n}\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n }\n  100% {\n    opacity: 1;\n }\n}\n.academy-hero-bg-col-1 {\n  padding: 0px 0px 0px 60px;\n  margin-bottom: 15%;\n  animation: fadeIn 5s;\n}\n.academy-hero-bg-col-1 .header-title-left {\n  font-family: \"Nelphim\";\n  font-size: 6em;\n  color: white;\n}\n.academy-hero-bg-col-2 {\n  padding-top: 10%;\n  /* padding-left: 30%; */\n  text-align: left;\n  animation: fadeIn 5s;\n}\n.academy-hero-bg-col-2 .header-title-right {\n  font-family: \"Nelphim\";\n  font-size: 6em;\n  color: white;\n}\n.academy-btn-hero-group {\n  position: absolute;\n  margin-top: -120px;\n  margin-left: 60px;\n}\n.section-wwr {\n  padding: 60px 0px;\n}\n.section-wwr-header {\n  display: block;\n  max-width: 1366px;\n  padding-bottom: 60px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.wwr-header-text {\n  width: calc(100% - 60px);\n  display: flex;\n}\n.wwr-header-text .section-item-1 {\n  width: 70%;\n  padding: 0px 30px 0px 60px;\n}\n.wwr-header-text .section-item-2 {\n  width: 30%;\n  padding: 0px 60px 0px 30px;\n}\n.wwr-header-image-group {\n  display: block;\n  max-width: 1366px;\n  padding: 0px 0px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.wwr-img {\n  width: calc(100% - 120px);\n  display: block;\n  padding: 0px 60px 0px 60px;\n  overflow: auto;\n}\n.wwr-img .wwr-img-group {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n  overflow: auto;\n}\n.wwr-img .wwr-img-group img {\n  width: 100%;\n  border-radius: 30px;\n}\n.section-empower {\n  display: block;\n  max-width: 1366px;\n  padding: 60px 0px 60px 0px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.section-empower .section-empower-group {\n  width: calc(100% - 120px);\n  margin-left: auto;\n  margin-right: auto;\n}\n.section-empower .empower-bg-image {\n  background: url(\"../images/BATrainingPillars.webp\");\n  background-size: cover;\n /* <------ */\n  background-repeat: no-repeat;\n  background-position: center center;\n  width: calc(100% - 120px);\n  height: 800px;\n  border-radius: 30px;\n  position: relative;\n}\n.empower-img-group-mobile {\n  display: none;\n}\n.section-empower-1 {\n  padding: 60px;\n  width: 65%;\n}\n.section-empower-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  gap: 24px;\n  padding: 60px 60px 45px 60px;\n  position: absolute;\n  bottom: 0px;\n}\n.empower-box {\n  padding: 30px;\n  border-radius: 30px;\n  border: 1px solid #ecebe6;\n  background: rgba(252, 252, 252, 0.2);\n /* Glassy Card */\n  box-shadow: 0px 119px 33px 0px rgba(135, 135, 135, 0), 0px 76px 31px 0px rgba(135, 135, 135, 0.01), 0px 43px 26px 0px rgba(135, 135, 135, 0.02), 0px 19px 19px 0px rgba(135, 135, 135, 0.04), 0px 5px 10px 0px rgba(135, 135, 135, 0.04);\n  backdrop-filter: blur(10px);\n}\n.empower-box .section-detail-large {\n  padding-bottom: 30px;\n}\n.empower-box .section-detail-small {\n  text-align: justify;\n}\n.section-reape-success {\n  display: block;\n  max-width: 1366px;\n  margin-left: auto;\n  margin-right: auto;\n  overflow: auto;\n  padding: 60px 0px;\n}\n\n.business-associate-wrapper{\n  display: block;\n  max-width: 1366px;\n  margin-left: auto;\n  margin-right: auto;\n  overflow: auto;\n  padding: 60px 0px;\n\n}\n.reape-grid {\n  display: grid;\n  grid-template-columns: 40% 60%;\n  grid-template-rows: 2fr;\n  width: 100%;\n  overflow: auto;\n}\n.reape-success-header-text {\n  width: calc(100% - 120px);\n  display: flex;\n  align-items: center;\n  padding-right: 60px;\n  padding-left: 60px;\n}\n\n.business-associate-header {\n  width: calc(100% - 120px);\n  display: flex;\n  align-items: center;\n  padding-right: 60px;\n  padding-left: 60px;\n  padding-bottom: 60px;\n}\n.reape-header-image-group {\n  width: calc(100% - 120px);\n  position: relative;\n  padding-left: 60px;\n  padding-bottom: 60px;\n}\n.reape-header-image-group .reape-image {\n  display: block;\n  width: 100%;\n  border-radius: 30px;\n}\n.reape-ba-image-group {\n  width: calc(100% - 60px);\n  position: relative;\n  padding-left: 60px;\n  padding-top: 60px;\n}\n.reape-ba-image-group .reape-ba-image {\n  display: block;\n  width: 100%;\n  border-radius: 30px;\n}\n.reape-ba-detail-mobile {\n  display: none;\n}\n.reape-ba-detail-web {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.reape-ba-detail-web .detail-web {\n  width: 60%;\n  text-align: justify;\n}\n.reape-ba-detail-web .section-detail-large {\n  padding-top: 120px;\n}\n.section-ba-news {\n  display: block;\n  max-width: 1366px;\n  margin-left: auto;\n  margin-right: auto;\n  overflow: auto;\n  padding-bottom: 60px;\n  padding-top: 60px;\n}\n.ba-news-header {\n  display: inline-flex;\n  padding-left: 60px;\n  padding-right: 60px;\n  width: calc(100% - 120px);\n  justify-content: space-between;\n  align-items: flex-end;\n  padding-bottom: 60px;\n}\n.ba-news-header .section-item-2 {\n  display: inline-flex;\n  gap: 12px;\n}\n\n.section-business-associate-content{\n  display: block;\n  width: calc(100% - 120px);\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.content-slider {\n  display: block;\n  max-width: 1366px;\n  margin-left: auto;\n  margin-right: auto;\n  overflow: auto;\n}\n.ba-news-content {\n  display: block;\n  width: calc(100% - 120px);\n  margin-left: auto;\n  margin-right: auto;\n}\n.ba-news-card {\n  display: flex;\n  width: 100%;\n  gap: 24px;\n  overflow-x: hidden;\n  scroll-behavior: smooth;\n  overflow-y: hidden;\n}\n.ba-news-detail-group {\n  width: calc(50% - 15px);\n  min-width: calc(50% - 15px);\n  background-color: #f7f7f7;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 30px;\n}\n.ba-news-detail-group .ba-news-image {\n  border-radius: 20px;\n}\n.ba-news-inner {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n}\n.ba-news-inner-detail {\n  width: 60%;\n  padding: 24px 24px 0px 24px;\n  line-height: 1.5;\n}\n.ba-news-inner-detail .detail-flex {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 30px;\n}\n.ba-news-image-group {\n  width: 40%;\n  padding: 24px 24px 24px 0px;\n}\n.ba-news-image-group .ba-news-image {\n  width: 100%;\n}\nbutton.left-arrow {\n  height: fit-content;\n  display: block;\n  border-radius: 20px;\n  border: 1px solid rgb(122 166 194 / 50%);\n  background: #eee;\n  backdrop-filter: blur(10px);\n  cursor: pointer;\n  display: flex;\n  padding: 18px 24px;\n  justify-content: center;\n  align-items: center;\n  color: #7ba7c2;\n}\nbutton.left-arrow:hover {\n  display: block;\n  border-radius: 20px;\n  border: 1px solid rgb(122 166 194 / 50%);\n  background: #7ba7c2;\n  backdrop-filter: blur(10px);\n  cursor: pointer;\n  display: flex;\n  padding: 18px 24px;\n  justify-content: center;\n  align-items: center;\n  color: #fcfcfc;\n}\nbutton.right-arrow {\n  height: fit-content;\n  border-radius: 20px;\n  border: 1px solid rgb(122 166 194 / 50%);\n  background: #eee;\n  backdrop-filter: blur(10px);\n  cursor: pointer;\n  display: flex;\n  padding: 18px 24px;\n  justify-content: center;\n  align-items: center;\n  color: #7ba7c2;\n}\nbutton.right-arrow:hover {\n  display: block;\n  border-radius: 20px;\n  border: 1px solid rgb(122 166 194 / 50%);\n  background: #7ba7c2;\n  backdrop-filter: blur(10px);\n  cursor: pointer;\n  display: flex;\n  padding: 18px 24px;\n  justify-content: center;\n  align-items: center;\n  color: #fcfcfc;\n}\n.section-faq {\n  display: block;\n  max-width: 1366px;\n  margin-left: auto;\n  margin-right: auto;\n  overflow: auto;\n  padding-bottom: 0px;\n}\n.section-faq-container {\n  display: grid;\n  padding: 60px;\n  width: calc(100% - 120px);\n  grid-template-columns: 40% 60%;\n  grid-template-rows: 1fr;\n  overflow: auto;\n}\n.business-associate-content{\n  display: block;\n  max-width: 1366px;\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: auto;\n  text-align: center;\n  padding: 0px 60px;\n \n}\n.business-associate-content-inner{\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n  width: 100%;\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n \n}\n.business-associate-content-inner .business-associate-card  {\n  width: 100%;\n  display: inline-grid;\n  text-align: left;\n  position: relative;\n}\n\n.business-associate-content-inner .business-associate-card .business-associate-img-box {\n  border-radius: 30px;\nwidth: 100%;\n  background: #d3d1c5;\n  display: in;\n  position: relative;\n  overflow: hidden;\n}\n.business-associate-content-inner .business-associate-card .business-associate-img-box .business-associate-img {\n  width: 100%;\n}\n.business-associate-content-inner .business-associate-card .business-associate-title-group {\n  padding: 20px 0px 0px 0px;\n  display: flex;\n  justify-content: space-between;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
